<template>
    <b-modal
        :hide-footer="true"
        :title="`Edição de Status ${item.descricao}`"
        centered
        size="md"
        id="show-status"
    >
        <div v-if="load" class="row p-3">
            <div class="p-3">
                <loading-animation
                    :active.sync="load"
                    :is-full-page="false"
                    :opacity="1"
                    color="#5895FF"
                />
            </div>
        </div>
        <div v-else>
            <div
                class="row d-flex justify-content-end"
                v-if="item.origem != 'Sistema'"
            >
                <form-input
                    mt="0"
                    grid="4"
                    label="Código"
                    v-model="item.codigo"
                />
                <form-input
                    mt="0"
                    grid="8"
                    label="Descrição do Status"
                    v-model="item.descricao"
                    :required="true"
                />
                <form-input-color
                    grid="6"
                    label="Cor do Status"
                    v-model="item.cor"
                />
                <form-toggle
                    grid="6"
                    class="mt-4 pt-1"
                    v-model="item.final"
                    label="Status Final?"
                />
                <button class="btn btn-success btn-sm" @click="editar">
                    <i class="mdi mdi-content-save"></i>
                    Salvar
                </button>
            </div>
            <div class="row" v-else>
                <div class="col-12">
                    <div class="alert alert-secondary" role="alert">
                        O Status
                        <strong
                            class="btn btn-light btn-sm"
                            v-html="item.titulo"
                        ></strong>
                        é padrão do sistema e não pode ser editado. Apenas
                        Status não são padrões podem ser editados.
                        <ul class="pl-3 mt-3">
                            <li><b>Código</b> {{ item.codigo }}</li>
                            <li>
                                <b>Cor</b>
                                <span :style="`background:${item.cor}`">{{
                                    item.cor
                                }}</span>
                            </li>
                            <li>
                                <b>Status Final</b>
                                {{ item.final == 1 ? "Sim" : "Não" }}
                            </li>
                        </ul>
                    </div>
                </div>
            </div>

            <div
                class="col-12 px-0"
                v-if="item.substatus && item.substatus.length > 0"
            >
                <h5 class="font-weight-bold">Substatus</h5>
                <ul v-for="sub in item.substatus" :key="sub.id">
                    <li>{{ sub.descricao }}</li>
                </ul>
            </div>
        </div>
    </b-modal>
</template>
<script>
export default {
    props: ["item"],
    data() {
        return { load: false };
    },
    methods: {
        editar() {
            this.load = true;
            axios
                .post("api/dashboard/admin/update/status", {
                    id: this.item.id,
                    descricao: this.item.descricao,
                    final: this.item.final,
                    cor: this.item.cor,
                })
                .then((response) => {
                    this.$emit("reload");
                    this.$snack.success({
                        button: false,
                        text: "Atualizado com sucesso.",
                    });
                    this.load = false;
                });
        },
    },
};
</script>
